// extracted by mini-css-extract-plugin
export var container = "_4a-0";
export var fallback = "_4a-5";
export var fallbackIcon = "_4a-6";
export var hidden = "_4a-2";
export var image = "_4a-3";
export var loaded = "_4a-4";
export var placeholder = "_4a-1";